import { roleList } from '@/modules/role-list.js'

export const getRoleTitle = {
  methods: {
    getRoleTitle(role) {
      return roleList[role] ? roleList[role].title : '?'
    },
    getRolesTitlesList(roles) {
      if (!roles) {
        return ''
      }
      return roles.map(role => this.getRoleTitle(role)).join('; ')
    }
  }
}
